import { render, staticRenderFns } from "./projectPayList.vue?vue&type=template&id=4801d63d"
import script from "./projectPayList.vue?vue&type=script&lang=js"
export * from "./projectPayList.vue?vue&type=script&lang=js"
import style0 from "./projectPayList.vue?vue&type=style&index=0&id=4801d63d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports